import React from "react";
import { ClipboardList } from "lucide-react";
import PageHeader from "components/ui/PageHeader";

const HistoryHeader: React.FC = () => (
    <PageHeader
        icon={<ClipboardList className="w-5 h-5" />}
        iconBg="bg-amber-50 dark:bg-amber-900/20"
        iconColor="text-amber-600 dark:text-amber-400"
        accentColor="bg-gradient-to-r from-amber-400 to-orange-500"
        title="Audit Logs & History"
        subtitle="Track changes, campaign events and template modifications"
    />
);

export default HistoryHeader;
